export default "__VITE_ASSET__d9243387__"